var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32.0003","cy":"32.0032","r":"23.2698","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M24.2202 28.4878H39.7798","stroke":"currentColor","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M24.2202 35.5181H39.7798","stroke":"currentColor","strokeLinecap":"round","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
